export class AccountSentLogsModel {
    sentLogs;
}
//# sourceMappingURL=account-sent-logs.js.map